import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const citizenServicesCategoryField =`
id
categoryUniqueId
categoryName
categoryDescription
`;



export const GET_CITIZEN_SERVICES_CATEGORY = gql`
query CitizenGetAllSectors{
    citizenGetCategories{
    ${baseResponseGraphqlField}
    data{
      ${citizenServicesCategoryField}
    }
  }
}
`
;
